import { z } from "zod";
import { dmaUserSchema } from "../dma-user";
export const dmaInitialGuessDataDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    content: z.unknown(),
    updatedAt: z.string().datetime(),
    updatedBy: z.nullable(dmaUserSchema),
});
